/**
 * App Update Component
 * Reusable component for checking and applying PWA updates
 */

import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonText } from '@ionic/angular/standalone';
import { PwaUpdateService } from '../../services/pwa-update.service';
import { Subscription } from 'rxjs';
import { LoadingButtonComponent } from '../loading-button/loading-button.component';

@Component({
  selector: 'crowdctrl-app-update',
  standalone: true,
  imports: [CommonModule, IonText, LoadingButtonComponent],
  templateUrl: './app-update.component.html',
  styleUrl: './app-update.component.css',
})
export class AppUpdateComponent implements OnInit, OnDestroy {
  /** Current app version to display */
  @Input() version: string = '';

  /** Whether an update is available */
  updateAvailable = false;

  /** Whether we're currently checking for updates */
  isChecking = false;

  /** Whether service worker is enabled */
  isServiceWorkerEnabled = false;

  private subscriptions: Subscription[] = [];

  constructor(private pwaUpdateService: PwaUpdateService) {}

  ngOnInit(): void {
    this.isServiceWorkerEnabled = this.pwaUpdateService.isEnabled;

    // Subscribe to update available state
    this.subscriptions.push(
      this.pwaUpdateService.updateAvailable$.subscribe((available) => {
        this.updateAvailable = available;
      }),
    );

    // Subscribe to checking state
    this.subscriptions.push(
      this.pwaUpdateService.isChecking$.subscribe((checking) => {
        this.isChecking = checking;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /**
   * Check for available updates
   */
  async checkForUpdates(): Promise<void> {
    await this.pwaUpdateService.checkForUpdates();
  }
}
